/** Guest-count bands for the enquiry form. */
export const guestOptions = ["1-2", "3-4", "5-8", "More than 8"] as const

/** The inn's room types, plus connecting rooms for families and groups. */
export const roomTypeOptions = [
    "One Queen Room",
    "Two Queen Room",
    "Connecting Rooms",
    "Not sure yet"
] as const

export const bookingIntro = "Send us your dates and we will get back to you to confirm. Prefer to talk? Call the hotel at 802-775-1608."

export const bookingHero = '/images/greenbrier/inn-lobby-5-a.jpg'

export const bookingHeroAlt = "Fireplace lounge at the Greenbrier Inn decorated for the holidays"

export const faqAuthor = {
    name: "Front Desk",
    role: "Greenbrier Inn, Killington",
    image: '/images/greenbrier/inn-lobby-2.jpg',
    note: "Still have questions? Give us a call or email us and we will help you plan your stay in Killington."
}

/** Questions guests ask, answered with the inn's own published details. */
export const faqItems = [
    {
        question: "How far is the Greenbrier Inn from the Killington ski lifts?",
        answer: "Five miles, about five minutes by car. We are centrally located right in the town of Killington, two miles from Killington's restaurants, bars and nightlife, and two miles from Green Mountain National Golf Course."
    },
    {
        question: "What are the rooms like?",
        answer: "All 21 guest rooms are air-conditioned and very large: 325 square feet plus a 45 square foot balcony. Each has one or two queen-sized beds, a private bath, color TV, telephone, hairdryer, small refrigerator, a table with two chairs and a private balcony or patio. Connecting rooms are available."
    },
    {
        question: "How do I get discounted lift tickets?",
        answer: "We offer discounted Killington and Pico lift tickets to our guests, saving up to 29% off window rates. They can only be purchased with a room reservation, over the phone or at the front desk. Call the hotel at 802-775-1608 for pricing and availability."
    },
    {
        question: "Is breakfast available?",
        answer: "Yes, a continental breakfast is one of our hotel amenities. You can also enjoy a cup of hot chocolate in our lounge by the fire."
    },
    {
        question: "Do you have Wi-Fi and a pool?",
        answer: "Wireless internet is available in the common areas, and our outdoor swimming pool is open in the summer. There are also hiking trails, snowshoeing and a trout stream on the property."
    },
    {
        question: "How do I find the inn?",
        answer: "We are at 2057 US Route 4, at the base of Access Road in Killington, Vermont 05751. Look for our large blue building on Route 4 and come down our driveway: the inn is located behind the gift shop."
    }
]
